import { Grid, IconButton, Typography, makeStyles } from "@material-ui/core";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import PropTypes from "prop-types";
import { useState } from "react";
import { MeasurementRowsStore } from "store";
import ContractMenu from "./ContractMenu";
import MeasurementMenu from "./MeasurementMenu";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "5.5vh",
    maxHeight: "34px",
    backgroundColor: theme.palette.blue.main,
  },
  iconMonetization: {
    margin: theme.spacing(0, 1),
    color: theme.palette.header,
  },
  title: { color: theme.palette.header, fontWeight: 500, flexGrow: 2 },
  buttonOptions: {
    padding: theme.spacing(1),
    color: theme.palette.header,
    marginRight: theme.spacing(2),
  },
}));

type IProps = {
  title: string;
  type: "contract" | "measurement";
  showSettings?: boolean;
};

const Header = ({ title, type, showSettings = false }: IProps) => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const classes = useStyles();
  const disableMenu =
    type === "measurement" && MeasurementRowsStore.updateHasFailed();

  const handleClick = (ev) => {
    setAnchorEl(ev.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container item xs className={classes.root} alignItems="center">
      <MonetizationOnIcon className={classes.iconMonetization} />
      <Typography className={classes.title}>{title}</Typography>
      {showSettings && (
        <>
          <IconButton
            className={classes.buttonOptions}
            onClick={handleClick}
            disabled={disableMenu}
          >
            <MoreHorizIcon />
          </IconButton>
          {type === "measurement" ? (
            <MeasurementMenu anchorEl={anchorEl} onClose={handleClose} />
          ) : (
            <ContractMenu anchorEl={anchorEl} onClose={handleClose} />
          )}
        </>
      )}
    </Grid>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;
